import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'mj-nice-select',
  templateUrl: './niceSelect.component.html',
  styleUrls: ['./niceSelect.component.scss'],
})
export class NiceSelectComponent
  implements OnInit, AfterViewChecked, OnChanges {
  @Output() onSelect = new EventEmitter<any>();

  // Styling related. Will make this more dynamically when there is time
  @Input() orange: boolean = false;

  @Input() triggerEventOnInit = true;
  @Input() fixedList = false;
  @Input() enabled: boolean = true;
  @Input() val: any;
  @Input() text: any;
  @Input() objects: any[];
  @Input() selectText;
  @Input() invalid: boolean = false;
  @Input() searchBar: boolean = false;
  @Input() searchPlaceholder: string = '';
  @Input() prefix: string = '';
  @Input() prefixStyle: any = '';
  @Input() placeholder: string;
  @Input() value: any = '';
  @Input() required: boolean = false;
  @Input() isValid: boolean = true;

  // Internal fields
  public selectValue: any = 'default';
  public showList: boolean;
  public elementRef;
  public selectedIndex = 0;
  public searchText: string = '';
  public filteredObjects: {} = {};

  constructor(element: ElementRef, private cdRef: ChangeDetectorRef) {
    this.showList = false;
    this.elementRef = element;
  }

  ngOnInit() {
    this.filteredObjects = this.objects;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value) {
      let obj;

      if (this.objects instanceof Array) {
        obj = this.objects.find(
          o => o[this.val] === (this.value && this.value[this.val])
        );
      } else {
        obj = this.objects[this.value];
      }
      if (obj) {
        this.setSelectValue(
          obj[this.val],
          obj[this.text],
          false,
          this.triggerEventOnInit
        );
      }
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  public toggleList() {
    this.showList = !this.showList;
  }

  public onSelectFocused(event) {
    this.showList = true;

    if (this.searchBar) {
      const input = event.target.getElementsByTagName('input')[0];

      if (input) {
        input.focus();
      }
    }
  }

  public setSelectValue(value, text, toggle = true, triggerEvent = true) {
    if (triggerEvent) {
      this.onSelect.emit(value);
    }
    this.selectValue = value;
    this.selectText = text;

    if (toggle) {
      this.toggleList();
    }
  }

  public checkSelectedValue(value) {
    return this.selectValue === value;
  }

  public checkSelectedIndex(index) {
    return index === this.selectedIndex;
  }

  public setSelectedIndexOnArrowKey(incrementValue) {
    if (
      this.selectedIndex + incrementValue <
        Object.keys(this.filteredObjects).length &&
      this.selectedIndex + incrementValue >= 0
    ) {
      this.selectedIndex += incrementValue;
    } else {
      this.selectedIndex = 0;
    }
  }

  public filterObjects() {
    // Sets all objects if search string is empty
    if (!this.searchText) {
      this.filteredObjects = this.objects;
      return;
    }

    this.toggleList();

    const filteredObjects = {};

    for (const key of Object.keys(this.objects)) {
      const textValue = this.objects[key][this.text].toLowerCase();

      if (textValue.indexOf(this.searchText.toLowerCase()) >= 0) {
        filteredObjects[key] = this.objects[key];
      }
    }
    this.filteredObjects = filteredObjects;
    this.cdRef.detectChanges();

    if (Object.keys(this.filteredObjects).length) {
      this.selectedIndex = 0;
    }

    this.toggleList();
  }

  public isEmpty(obj) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return true;
  }

  public blurOnSelect(event) {
    // Removes focus on selector
    event.target.parentElement.parentElement.blur();
  }

  public trackByFn(index, item) {
    return index; // or item.id
  }
}
